'use strict'

;(function () {
	const closeDelayTimers = new WeakMap()
	const closeScrollHandlers = new WeakMap()
	const openScrollHandlers = new WeakMap()
	const exitIntentHandlers = new WeakMap()

	const adpPopup = {
		sPrevious: window.scrollY,
		sDirection: 'down',
		eventsBound: false,

		init(root = document) {
			this.bindEvents()
			this.collectPopups(root).forEach((popup) => {
				this.setupPopup(popup)
			})
		},

		collectPopups(root) {
			if (!root) return []

			if (root instanceof Element) {
				const popups = Array.from(root.querySelectorAll('.popup'))
				if (root.matches('.popup')) {
					popups.unshift(root)
				}
				return popups
			}

			return Array.from(document.querySelectorAll('.popup'))
		},

		bindEvents() {
			if (this.eventsBound) return

			this.eventsBound = true

			window.addEventListener(
				'scroll',
				() => {
					const scrollCurrent = window.scrollY
					this.sDirection = scrollCurrent > this.sPrevious ? 'down' : 'up'
					this.sPrevious = scrollCurrent
				},
				{passive: true}
			)

			document.addEventListener('click', (event) => {
				const popupClose = event.target.closest('.popup-close')
				if (popupClose) {
					event.preventDefault()
					this.closePopup(popupClose)
					return
				}

				const popupAccept = event.target.closest('.popup-accept')
				if (popupAccept) {
					event.preventDefault()
					this.acceptPopup(popupAccept)
					this.closePopup(popupAccept)
					return
				}

				const ageClose = event.target.closest('.age-verification__popup-close')
				if (ageClose) {
					event.preventDefault()
					this.agePopup(ageClose)
					this.closePopup(ageClose)
					return
				}

				const ageDeclined = event.target.closest('.age-verification__button-no')
				if (ageDeclined) {
					event.preventDefault()
					this.ageDeclined(ageDeclined)
					return
				}

				if (event.target.classList.contains('popup-overlay')) {
					document
						.querySelectorAll('.popup-open[data-overlay-close="true"]')
						.forEach((popup) => {
							this.closePopup(popup)
						})
				}

				this.openManualPopupFromEvent(event)
			})

			document.addEventListener('keyup', (event) => {
				if (event.key === 'Escape') {
					document
						.querySelectorAll('.popup-open[data-esc-close="true"]')
						.forEach((popup) => {
							this.closePopup(popup)
						})
				}

				if (event.key === 'F4') {
					document
						.querySelectorAll('.popup-open[data-f4-close="true"]')
						.forEach((popup) => {
							this.closePopup(popup)
						})
				}
			})

			document.addEventListener('shopify:section:load', (event) => {
				this.init(event.target)
			})

			document.addEventListener('shopify:section:unload', () => {
				document.body.classList.remove('popup-scroll-hidden')
			})
		},

		setupPopup(popup) {
			if (popup.dataset.popupInitialized === 'true') return

			popup.dataset.popupInitialized = 'true'

			if (popup.dataset.openTrigger === 'manual') {
				this.bindManualTrigger(popup)
			}

			if (!this.isAllowPopup(popup) && !popup.classList.contains('age-verification')) {
				return
			}

			this.openTriggerPopup(popup)
		},

		bindManualTrigger(popup) {
			const selector = popup.dataset.openManualSelector
			if (!selector) return

			let triggerElements = []

			try {
				triggerElements = Array.from(document.querySelectorAll(selector))
			} catch (error) {
				console.error(error)
				return
			}

			triggerElements.forEach((trigger) => {
				trigger.classList.add('popup-trigger')
			})
		},

		openManualPopupFromEvent(event) {
			document
				.querySelectorAll('.popup[data-open-trigger="manual"]')
				.forEach((popup) => {
					if (!popup.isConnected) return

					const selector = popup.dataset.openManualSelector
					if (!selector) return

					let trigger
					try {
						trigger = event.target.closest(selector)
					} catch (error) {
						return
					}

					if (!trigger) return

					event.preventDefault()
					popup.classList.remove('popup-already-opened')
					this.openPopup(popup)

					if (trigger.classList.contains('popup')) {
						this.closePopup(trigger)
					}
				})
		},

		openTriggerPopup(popup) {
			const trigger = popup.dataset.openTrigger

			if (trigger === 'none') {
				const ageVerification = this.getStorage(
					`popup-age-${popup.dataset.id || 0}`
				)
				if (!ageVerification) this.openPopup(popup)
				return
			}

			if (trigger === 'delay' && popup.dataset.popupOpenDelayBound !== 'true') {
				popup.dataset.popupOpenDelayBound = 'true'
				window.setTimeout(() => {
					this.openPopup(popup)
				}, Number(popup.dataset.openDelayNumber || 0) * 1000)
				return
			}

			if (trigger === 'exit' && !exitIntentHandlers.has(popup)) {
				let showExit = true
				const handler = (event) => {
					const scroll =
						window.pageYOffset || document.documentElement.scrollTop

					if (event.pageY - scroll < 7 && showExit) {
						this.openPopup(popup)
						showExit = false
					}
				}

				exitIntentHandlers.set(popup, handler)
				document.addEventListener('mousemove', handler)
				return
			}

			if (trigger === 'scroll' && !openScrollHandlers.has(popup)) {
				const handler = () => {
					const pointScrollType = popup.dataset.openScrollType
					const pointScrollPosition = Number(
						popup.dataset.openScrollPosition || 0
					)

					if (
						pointScrollType === 'px' &&
						window.scrollY >= pointScrollPosition
					) {
						this.openPopup(popup)
					}

					if (
						pointScrollType === '%' &&
						this.getScrollPercent() >= pointScrollPosition
					) {
						this.openPopup(popup)
					}
				}

				openScrollHandlers.set(popup, handler)
				document.addEventListener('scroll', handler, {passive: true})
				return
			}

			if (trigger === 'accept') {
				const accept = this.getStorage(`popup-accept-${popup.dataset.id || 0}`)
				if (!accept) {
					this.openPopup(popup)
				}
			}
		},

		closeTriggerPopup(popup) {
			const trigger = popup.dataset.closeTrigger

			if (trigger === 'delay') {
				const timer = window.setTimeout(() => {
					this.closePopup(popup)
				}, Number(popup.dataset.closeDelayNumber || 0) * 1000)
				closeDelayTimers.set(popup, timer)
			}

			if (trigger === 'scroll') {
				const handler = () => {
					const pointScrollType = popup.dataset.closeScrollType
					const pointScrollPosition = Number(
						popup.dataset.closeScrollPosition || 0
					)
					const initScrollPx = Number(popup.dataset.initScrollPx || 0)
					const initScrollPercent = Number(
						popup.dataset.initScrollPercent || 0
					)

					if (pointScrollType === 'px') {
						if (
							this.sDirection === 'up' &&
							window.scrollY < initScrollPx - pointScrollPosition
						) {
							this.closePopup(popup)
						}

						if (
							this.sDirection === 'down' &&
							window.scrollY >= initScrollPx + pointScrollPosition
						) {
							this.closePopup(popup)
						}
					}

					if (pointScrollType === '%') {
						if (
							this.sDirection === 'up' &&
							this.getScrollPercent() < initScrollPercent - pointScrollPosition
						) {
							this.closePopup(popup)
						}

						if (
							this.sDirection === 'down' &&
							this.getScrollPercent() >=
								initScrollPercent + pointScrollPosition
						) {
							this.closePopup(popup)
						}
					}
				}

				closeScrollHandlers.set(popup, handler)
				document.addEventListener('scroll', handler, {passive: true})
			}
		},

		clearCloseTrigger(popup) {
			if (closeDelayTimers.has(popup)) {
				window.clearTimeout(closeDelayTimers.get(popup))
				closeDelayTimers.delete(popup)
			}

			if (closeScrollHandlers.has(popup)) {
				document.removeEventListener('scroll', closeScrollHandlers.get(popup))
				closeScrollHandlers.delete(popup)
			}
		},

		openPopup(popup) {
			if (!popup) return
			if (popup.classList.contains('popup-open')) return
			if (popup.classList.contains('popup-already-opened')) return

			if (popup.dataset.bodyScrollDisable === 'true') {
				document.body.classList.add('popup-scroll-hidden')
			}

			const limit =
				parseInt(this.getStorage(`popup-${popup.dataset.id}`) || 0, 10) + 1

			this.setStorage(`popup-${popup.dataset.id}`, limit, {
				expires: popup.dataset.limitLifetime,
			})

			popup.classList.add('popup-open')
			popup.dataset.initScrollPx = String(window.scrollY)
			popup.dataset.initScrollPercent = String(this.getScrollPercent())

			this.applyAnimation(popup, popup.dataset.openAnimation)
			this.closeTriggerPopup(popup)
		},

		agePopup(target) {
			const popup = this.getPopup(target)
			if (!popup) return

			this.setStorage(`popup-age-${popup.dataset.id}`, 1, {expires: 360})
		},

		ageDeclined(target) {
			const popup = this.getPopup(target)
			if (!popup) return

			popup
				.querySelector('.age-verification__question')
				?.classList.remove('show')
			popup
				.querySelector('.age-verification__declined')
				?.classList.add('show')
		},

		acceptPopup(target) {
			const popup = this.getPopup(target)
			if (!popup) return

			this.setStorage(`popup-accept-${popup.dataset.id}`, 1, {expires: 360})
		},

		closePopup(target) {
			const popup = this.getPopup(target)
			if (!popup) return

			this.applyAnimation(popup, popup.dataset.exitAnimation, () => {
				popup.classList.add('popup-already-opened')
				popup.classList.remove('popup-open')
				document.body.classList.remove('popup-scroll-hidden')
				this.clearCloseTrigger(popup)
			})
		},

		isAllowPopup(popup) {
			const limitDisplay = parseInt(popup.dataset.limitDisplay || 0, 10)
			const limitDisplayCookie = parseInt(
				this.getStorage(`popup-${popup.dataset.id}`),
				10
			)

			if (
				limitDisplay &&
				limitDisplayCookie &&
				limitDisplayCookie >= limitDisplay
			) {
				return false
			}

			return true
		},

		applyAnimation(element, name, callback) {
			const popup = this.getPopup(element)
			if (!popup) return

			const finish = () => {
				if (typeof callback === 'function') {
					callback()
				}
			}

			const overlayName =
				typeof callback === 'function' ? 'popupExitFade' : 'popupOpenFade'
			const overlay = popup.nextElementSibling?.classList.contains('popup-overlay')
				? popup.nextElementSibling
				: null
			const popupWrap = popup.querySelector('.popup-wrap')

			if (overlay) {
				overlay.classList.add('popup-animated', overlayName)
				overlay.addEventListener(
					'animationend',
					() => {
						overlay.classList.remove('popup-animated', overlayName)
					},
					{once: true}
				)
			}

			if (!popupWrap || !name) {
				finish()
				return
			}

			popupWrap.classList.add('popup-animated', name)
			popupWrap.addEventListener(
				'animationend',
				() => {
					popupWrap.classList.remove('popup-animated', name)
					finish()
				},
				{once: true}
			)
		},

		getPopup(target) {
			if (target instanceof Element) {
				return target.closest('.popup') || target
			}

			return null
		},

		getCookie(name) {
			const matches = document.cookie.match(
				new RegExp(
					'(?:^|; )' +
						name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
						'=([^;]*)'
				)
			)

			return matches ? decodeURIComponent(matches[1]) : undefined
		},

		getStorage(key) {
			const item = localStorage.getItem(key)

			if (item) {
				try {
					const parsed = JSON.parse(item)
					if (parsed.expires && Date.now() > parsed.expires) {
						localStorage.removeItem(key)
						return undefined
					}
					return parsed.value
				} catch {
					return undefined
				}
			}

			const cookieValue = this.getCookie(key)
			if (cookieValue !== undefined) {
				this.setStorage(key, cookieValue)
				return cookieValue
			}

			return undefined
		},

		setStorage(key, value, options = {}) {
			const data = {
				value,
				expires: null,
			}

			if (options.expires) {
				const expiresDate = new Date()
				expiresDate.setDate(
					expiresDate.getDate() + parseInt(options.expires, 10)
				)
				data.expires = expiresDate.getTime()
			}

			localStorage.setItem(key, JSON.stringify(data))
		},

		getScrollPercent() {
			const h = document.documentElement
			const b = document.body
			const st = 'scrollTop'
			const sh = 'scrollHeight'

			return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100
		},
	}

	window.adpPopup = adpPopup
	adpPopup.init()
})()
